$(document).ready(function (e) {

    $("#table-users").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'get-users',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'name', name: 'name'},
            {data: 'email', name: 'email'},
        ],
        "columnDefs": [{
            "targets": 3,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status)
                return '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-user-status btn-sm"  ' +
                    'data-user ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                    'edit-user btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Generar nueva contraseñá" class="btn button_almadia ' +
                    'update-password-user btn-sm"' +
                    'data-user ="' + row.id + '"><i class="fa-solid fa-unlock-keyhole"></i></button>'
            }
        }]
    });
    const list_users = $("#table-users").DataTable()

    $("#table-users tbody").on('click','.change-user-status',function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('userId',$(this).data('user'))
        $(".loader_").addClass("loading")
        sendData(data, '/admin/update-status-user', 'modal-users')
    })

    $("#add-user").on('click', function (e) {
        e.preventDefault()
        $("#form-users")[0].reset()
        $(".item-id").val('');
        $(".item-rol").val('');
        $('.item-rol').trigger("chosen:updated");
        $(".modal-title").text('Agregar usuario')
        $("#modal-users").modal('show')
    })

    $("#table-users tbody").on('click', '.edit-user', function (e) {
        e.preventDefault()
        $(".modal-title").text('Editar usuario')
        rowData = list_users.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            if(index === "rol") {
                $('.item-rol').val(value);
                $('.item-rol').trigger("chosen:updated");
            }
            $(".item-" + index).val(value);
        })
        $("#modal-users").modal('show')
    })

    $("#table-users tbody").on('click', '.update-password-user', function (e) {
        e.preventDefault()
        getInputPassword($(this).data('user'))
    })

    async function getInputPassword(user_id) {
        const { value: password } = await swal.fire({
            title: 'Ingresa nueva contraseña',
            input: 'password',
            inputPlaceholder: 'Ingresa una contraseña',
            confirmButtonColor: "#FF5001",
            confirmButtonText: "Actualizar",
            inputAttributes: {
                maxlength: 50,
                autocapitalize: 'off',
                autocorrect: 'off'
            }
        })

        if (password) {
            let data = new FormData()
            data.append('password',`${password}`)
            data.append('userId',user_id)
            $(".loader_").addClass("loading")
            sendData(data, '/admin/update-password-user', 'modal-users')
        }
    }

    $("#form-users").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $(".loader_").addClass("loading")
        sendData(data, '/admin/data-user', 'modal-users')
    })

    function sendData(data, route, modal) {
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                        $("#table-users").DataTable().ajax.reload();
                        $("#modal-users").modal("hide")
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }
})
